import 'babel-polyfill';
import 'vuetify/dist/vuetify.min.css';
import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify';

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    warning: "#ff0000",
  },
});

new Vue({
  render: h => h(App),
}).$mount('#app')
